import { createSelector } from 'reselect'

export const getVehicleFleetboardConfigurations = state => state.vehicleFleetboardConfigurations.getIn(['all', 'objects'])

export const createGetVehicleFleetboardConfigurationByIDSelector = id =>
    createSelector([getVehicleFleetboardConfigurations], vehicleFleetboardConfigurations => vehicleFleetboardConfigurations.get(String(id)))
